import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Loading } from "../../views/Loading"
import { carrotClient } from "#/utils/CarrotClient"
import { HelpCenterSsoResponse } from "../../../types/zendeskTypes"
import { reportError } from "../../../utils/ErrorReporting"
import Settings from "#/utils/CarrotConfig"
import { AppAccessError } from "#/components/views/AppAccessError"
import { submitZendeskSsoForm } from "#/utils/zendesk/submitZendeskSsoForm"

const RETURN_TO = "return_to"

export function HelpCenterLoginContainer(): JSX.Element {
  const urlSearchParams = new URLSearchParams(useLocation().search)
  const returnToUrlString = urlSearchParams.get(RETURN_TO) || Settings.ZENDESK_GUIDE
  const [error, setError] = useState(false)

  useEffect(() => {
    carrotClient
      .getHelpCenterSsoPayload()
      .then((response: HelpCenterSsoResponse) => {
        if (response.abort || !response.jwt || !response.postUrl || !response.locale) {
          setError(true)
          return
        }
        submitZendeskSsoForm({
          jwt: response.jwt,
          postUrl: response.postUrl,
          locale: response.locale,
          returnTo: returnToUrlString
        })
      })
      .catch((err) => {
        reportError(err)
        setError(true)
      })
  }, [returnToUrlString])

  return error ? <AppAccessError /> : <Loading />
}
